<template>
  <div v-if="enabled">
    <h4>{{ label }}</h4>
    <div class="category-filter">
      <select-dropdown
        v-model="selectedFilter"
        :items="listItems"
        :name="filter.filterBy"
      />
    </div>
  </div>
</template>

<script>
import SelectDropdown from '../../components/ui-elements/select-dropdown'
import mixins from './mixins'

export default {
  name: 'generic-filter-select',
  components: {
    'select-dropdown': SelectDropdown
  },
  mixins: [
    mixins
  ],
  props: {
    'products': {
      type: Array,
      required: true
    },
    'filter': {
      type: Object,
      required: true
    },
    'value': {
      type: Object,
      required: true
    }
  },
  computed: {
    enabled: function() {
      return (this.listItems.length > 0)
    },
    selectedFilter: {
      get() {
        return this.value[ this.filter.filterBy ]
      },
      set(v) {
        let newValue = JSON.parse(JSON.stringify(this.value))
        if (v === '_clear_') {
          newValue[this.filter.filterBy] = []
        }
        else if (newValue[this.filter.filterBy].length > 0 && newValue[this.filter.filterBy].indexOf(v) !== -1) {
          newValue[this.filter.filterBy] = newValue[this.filter.filterBy].filter(x => x !== v)
        }
        else {
          let currentValue = Object.assign([], this.value[this.filter.filterBy])
          if (!currentValue.includes(v)) {
            newValue[this.filter.filterBy].push(v)
          }
        }
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style scoped lang="scss">
    .category-filter {
        position: relative;
        min-height: 4em;
        margin: 1em 0;
    }
    .range-slider {
        padding: 1em;

        .range-slider-label {
            position: relative;
            color: var(--main-primary);

            .minimum {
                text-align: left;
                float: left;
                font-weight: bold;
            }
            .maximum {
                text-align: right;
                float: right;
                font-weight: bold;
            }
        }
       ::v-deep .vue-slider-component {
            .vue-slider-process {
                background-color: var(--main-primary);
            }
            .vue-slider-tooltip {
                display: none;
                background-color: var(--main-primary);
                border-color: var(--main-primary);
            }
        }
    }
</style>
